import MainLayout from '../layouts/main';

function DefaultPage() {
  return <MainLayout loginRequired={false} />;
}

export default DefaultPage;
